import { render } from "./what-is-maintenance.vue?vue&type=template&id=2b1c709a"
import script from "./what-is-maintenance.vue?vue&type=script&lang=js"
export * from "./what-is-maintenance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__